import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class' ;
import { TICKET_MODULE_NAMESPACE, TICKET_LOADERS } from '../../store/ticket';
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_LOADERS } from '../../store/reception/reception-types.store';

const TicketStore= namespace(TICKET_MODULE_NAMESPACE)
const ReceptionStore= namespace(RECEPTION_MODULE_NAMESPACE)

@Component
class SearchSelectorComponent extends Vue {

  @Prop({ required: false })
  value: any;

  @Prop({ default: null, type: [String] })
  label: string;
  @Prop({ default: '300', type: [String] })
  maxHeight: string;
  @Prop({ required: false, type: [Boolean] })
  multiple: boolean;



  @Prop({ default: [], type: [Array] })
  items: any[];

  @TicketStore.Getter('loaders') ticket_loaders: Map<string,boolean>
  @ReceptionStore.Getter('loaders') reception_loaders: Map<string,boolean>

  get vModel(): any { return this.value; }
  set vModel(val: any) {
    this.$emit('input', val);
  }

  get hasProps(): boolean {
    return Object.keys(this.$slots).length > 1;
  }
  get coItems() {
    if (!this.multiple) {
      return this.items;
    }
    return this.items;
  }
  get extendItemCount(): number {
    return this.vModel.length - 1
  }

  get coLoader(): boolean {
    return this.ticket_loaders.get(TICKET_LOADERS.LIST_FILTERS)
         || this.reception_loaders.get(RECEPTION_LOADERS.FILTERS)
  }

  getVisibility(index: number): boolean {
    return this.vModel && (index === this.vModel.length - 1);
  }
  handleChange(event) {
    console.log(event)
    this.$emit('change');
  }
  handleInput(event) {
    console.log(event)
    this.$emit('input');
  }

}

export default SearchSelectorComponent;



// WEBPACK FOOTER //
// ./src/components/search-selector/index.ts